import { Fragment } from 'react';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { MagicLink } from '../../../../components/AppLink';
import Arrow from '../../../../components/Arrow';
import { AlignTravel } from '../../../../components/ArrowLink';
import ArrowSrc from '../../../../images/arrowRightDark.svg';

const Price = styled.p`
  ${tw`text-secondary400 mr-abs1`};
  min-width: 35px;
`;

interface TravelListItemProps {
  travel: {
    destination: string;
    mean: string;
    origin: string;
    price: number;
  };
}

const TravelListItem: React.FC<TravelListItemProps> = ({ travel }) => (
  <Fragment>
    <AlignTravel>
      <Price>{travel.price}€</Price>
      <p>
        {travel.mean} {travel.origin} - {travel.destination}
      </p>
    </AlignTravel>
    <Arrow alt={'Arrow icon'} parentHover={MagicLink} src={ArrowSrc} />
  </Fragment>
);

export default TravelListItem;
